import React, { useState } from 'react';
import Modal from 'react-modal';
import { useNavigate } from "react-router-dom";
import './CreateUserModal.css';

const CreateInternalUserModal = ({ isOpen, onRequestClose, onUserCreated }) => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [contactNumber, setContactNumber] = useState('');
	const [password, setPassword] = useState('');
	const navigate = useNavigate();

	const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	const isValidContactNumber = (number) => /^\d{10,15}$/.test(number);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!isValidEmail(email)) {
			alert('Please enter a valid email address.');
			return;
		}

		if (!isValidContactNumber(contactNumber)) {
			alert('Please enter a valid contact number.');
			return;
		}

		const newUser = { firstName, lastName, email, contactNumber, password };

		try {
			const response = await fetch('https://api.hgcdental.clinic/api/internalusers', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(newUser),
			});

			let data;
			try {
				data = await response.json(); // Try to parse JSON if possible
			} catch (err) {
				console.error('Error parsing response JSON:', err);
			}

			if (!response.ok) {
				alert(data?.message || 'Failed to create the user. Please try again later.');
				return;
			}

			alert('User created successfully!');
			onUserCreated(data);
		} catch (error) {

			// console.error('Error:', error);
			// alert('Failed to create the user. Please try again later.');

		}
	};


	return (
		<Modal isOpen={isOpen} onRequestClose={onRequestClose} className="modal" overlayClassName="overlay">
			<button className="close-icon" onClick={onRequestClose}>&times;</button>
			<h2>Create Internal User</h2>
			<div className="modal-divider-3" />
			<form onSubmit={handleSubmit}>
				<div>
					<label>First Name:</label>
					<input
						type="text"
						value={firstName}
						onChange={(e) => setFirstName(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Last Name:</label>
					<input
						type="text"
						value={lastName}
						onChange={(e) => setLastName(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Email:</label>
					<input
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Contact Number:</label>
					<input
						type="text"
						value={contactNumber}
						onChange={(e) => setContactNumber(e.target.value)}
						required
					/>
				</div>
				<div>
					<label>Password:</label>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
				</div>
				<div className="modal-divider-3" />
				<button type="submit">Create Internal User</button>
			</form>
		</Modal>
	);
};

export default CreateInternalUserModal;